import {z} from 'zod';

// NOTE: the copy-pasted parts of the schema below CANNOT be extracted to a common schema because they are not flattened in the JSON schema, and the LLM doesn't support such unflattened schema refs.
const getCellsThatNeedToBeSanitizedResponseSchema = z.object({
  cellValueOverrides: z.array(
    z.object({
      rowIndex: z.number(),
      columnIndex: z.number(),
      columnHeader: z.string(),
      fixedValue: z.string(),
    }),
  ),
  unresolvedCells: z.array(
    z.object({
      rowIndex: z.number(),
      columnIndex: z.number(),
      columnHeader: z.string(),
      value: z.string(),
      issue: z.string(),
    }),
  ),
});

export {getCellsThatNeedToBeSanitizedResponseSchema};
